import React from "react";
import PropTypes from "prop-types";
import M from "materialize-css";

import Edit from "../shared/Edit";
import AdminOnly from "../shared/AdminOnly";

import { useOrganization } from "../../hooks/useOrganization";
import { useTooltip } from "../../hooks/useTooltip";

export default function OrganizationTr({ org }) {
  const tooltipRef = useTooltip();
  const organization = useOrganization();
  const currentOrgId = organization.current.id;

  const handleSetCurrentOrg = (org) => {
    return (e) => {
      e.preventDefault();
      const el = tooltipRef.current;
      M.Tooltip.getInstance(el).close();
      organization.setCurrent(org);
    };
  };

  const isCurrent = currentOrgId === org.id;
  const colorClass = isCurrent ? "green" : "grey";

  const tooltip = isCurrent
    ? "This is your currently selected organization"
    : "Click to select this organization as your current organization";

  return (
    <tr key={org.id}>
      <td>{org.name}</td>
      <td>
        {isCurrent && (
          <AdminOnly>
            <Edit
              at={`/organizations/${org.id}/edit`}
              tooltip="Edit this organization"
            />
          </AdminOnly>
        )}
      </td>
      <td>
        <i
          className={`material-icons ${colorClass}-text cursor-pointer`}
          onClick={isCurrent ? (e) => null : handleSetCurrentOrg(org)}
          data-tooltip={tooltip}
          data-position="left"
          ref={tooltipRef}
        >
          check_circle
        </i>
      </td>
    </tr>
  );
}

OrganizationTr.propTypes = {
  org: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};
